import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, Col, Spinner } from "reactstrap"
import { get } from "helpers/api_helper"

const QualityReport = () => {
  const [loading, setLoading] = useState(true)
  const [stats, setStats] = useState(null)

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await get("api/org")
        if (res.status === 200 && res.response) {
          setStats(res.response.orders)
        }
      } catch (err) {
        console.error("Error fetching quality stats:", err)
      } finally {
        setLoading(false)
      }
    }
    fetchStats()
  }, [])

  const n = stats ? parseInt(stats.new) || 0 : 0
  const r = stats ? parseInt(stats.redo) || 0 : 0
  const c = stats ? parseInt(stats.corr) || 0 : 0
  const total = n + r + c

  const ftr = total > 0 ? (n / total) * 100 : 100
  const redo = total > 0 ? (r / total) * 100 : 0
  const corr = total > 0 ? (c / total) * 100 : 0

  let redoColor = "text-success"
  let corrColor = "text-success"
  let alertClass = "alert-success border-success text-success bg-success bg-soft"
  let alertIcon = "mdi-check-decagram"
  let alertMsg = "Excellent precision! Quality is within global targets."

  if (redo >= 8) {
    redoColor = "text-danger"
    alertClass = "alert-danger border-danger text-danger bg-danger bg-soft"
    alertIcon = "mdi-alert-decagram"
    alertMsg = "High Redo Rate! Focus on impression accuracy."
  } else if (redo >= 4) {
    redoColor = "text-warning"
    alertClass = "alert-warning border-warning text-warning bg-warning bg-soft"
    alertIcon = "mdi-alert-circle"
    alertMsg = "Moderate Redo Rate. Audit top redo categories."
  }

  if (corr >= 5) {
    corrColor = "text-warning"
  }

  return (
    <Card className="shadow-none border">
      <CardBody className="p-4">
        <div>
          <h4 className="card-title mb-3 font-size-15">
            <i className="mdi mdi-shield-check-outline text-primary me-2 font-size-18"></i>
            Quality & Performance Analyzer
          </h4>

          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner color="primary" size="sm" />
            </div>
          ) : (
            <>
              {/* Stacked Progress Bar */}
              <div className="progress progress-sm mb-2" style={{ height: "10px", borderRadius: "50px", overflow: "hidden" }}>
                <div
                  className="progress-bar bg-success"
                  role="progressbar"
                  style={{ width: `${ftr}%` }}
                  aria-valuenow={ftr}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
                <div
                  className="progress-bar bg-warning"
                  role="progressbar"
                  style={{ width: `${corr}%` }}
                  aria-valuenow={corr}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
                <div
                  className="progress-bar bg-danger"
                  role="progressbar"
                  style={{ width: `${redo}%` }}
                  aria-valuenow={redo}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>

              {/* Progress Legend */}
              <div className="d-flex justify-content-between font-size-11 text-muted mb-4">
                <span>
                  <span className="badge p-1 bg-success me-1"> </span> New ({ftr.toFixed(1)}%)
                </span>
                <span>
                  <span className="badge p-1 bg-warning me-1"> </span> Corr ({corr.toFixed(1)}%)
                </span>
                <span>
                  <span className="badge p-1 bg-danger me-1"> </span> Redo ({redo.toFixed(1)}%)
                </span>
              </div>

              {/* Quality Key Indicators */}
              <Row className="text-center border-top pt-3">
                <Col xs="4" className="border-end">
                  <h5 className="font-size-14 mb-1 text-success fw-bold">{ftr.toFixed(1)}%</h5>
                  <p className="text-muted font-size-10 text-truncate mb-0">FTR Rate</p>
                  <small className="text-muted font-size-9">Target &gt;95%</small>
                </Col>
                <Col xs="4" className="border-end">
                  <h5 className={`font-size-14 mb-1 fw-bold ${redoColor}`}>{redo.toFixed(1)}%</h5>
                  <p className="text-muted font-size-10 text-truncate mb-0">Redo Rate</p>
                  <small className="text-muted font-size-9">Target &lt;4%</small>
                </Col>
                <Col xs="4">
                  <h5 className={`font-size-14 mb-1 fw-bold ${corrColor}`}>{corr.toFixed(1)}%</h5>
                  <p className="text-muted font-size-10 text-truncate mb-0">Correction</p>
                  <small className="text-muted font-size-9">Target &lt;5%</small>
                </Col>
              </Row>
            </>
          )}
        </div>

        {!loading && (
          <div className={`alert ${alertClass} mb-0 mt-3 p-2 text-center font-size-11`} style={{ borderRadius: "8px" }} role="alert">
            <i className={`mdi ${alertIcon} me-2 font-size-13 align-middle`}></i>
            {alertMsg}
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default QualityReport
